import { Container, Grid, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";

import DriverRequestDetails from "@/components/Driver/DriverRequestDetails";
import { ConfirmationDialogButton } from "@/components/Driver/DriverRequestDetails/confirmation-dialog-button";
import {
  useCancelRejectDriverRequestMutation,
  useGetDriverByIdQuery,
} from "@/libs/generated/hooks";
import {
  DRIVER_ACTIONS,
  ERROR_MESSAGES,
  NAVIGATION_ROUTES,
  SUCCESS_MESSAGES,
  TOAST_CONFIG,
} from "@/utils/constants/driver-actions";

function RefusedDriverDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  if (!id) throw new Error("no driver id in params");

  const {
    data,
    error,
    isPending: loading,
  } = useGetDriverByIdQuery({
    GetByIdInput: {
      id: Number(id),
    },
  });

  const cancelRejectDriver = useCancelRejectDriverRequestMutation({
    onSuccess: () => {
      toast.success(t(SUCCESS_MESSAGES.CANCEL_REJECT), TOAST_CONFIG);
      navigate(NAVIGATION_ROUTES.GO_BACK);
    },
    onError: (err: any) => {
      toast.error(err.message || t(ERROR_MESSAGES.GENERIC), TOAST_CONFIG);
    },
  });

  const isCancellingReject = cancelRejectDriver.isPending;

  if (loading) return <p>{t("common.loading")}</p>;

  if (error) {
    return <p>{t("common.error.generic")}</p>;
  }

  if (!data?.getDriverById) {
    return <p>{t("common.no-data")}</p>;
  }

  const driverData = data.getDriverById;
  return (
    <Container sx={{ py: 4 }} maxWidth="xl">
      <Grid container spacing={2}>
        <DriverRequestDetails
          driverData={driverData}
          actions={
            <ConfirmationDialogButton
              buttonText={DRIVER_ACTIONS.CANCEL_REJECT.buttonText}
              title={DRIVER_ACTIONS.CANCEL_REJECT.title}
              buttonColor={theme.palette.warning.main}
              description={DRIVER_ACTIONS.CANCEL_REJECT.confirmation}
              icon={DRIVER_ACTIONS.CANCEL_REJECT.icon}
              actionIsLoading={isCancellingReject}
              onConfirm={() => {
                cancelRejectDriver.mutate({
                  input: { email: driverData.email },
                });
              }}
            />
          }
        />
      </Grid>
    </Container>
  );
}

export default RefusedDriverDetails;
